module.exports = __webpack_public_path__ + "static/media/nittai.2bbde91c.jpg";